import { Component, Input } from "@angular/core";
import { BaseComponent } from "../..";
import { CodePanelValuesModel } from "./codePanelValueModel";
import { CodeDisplayStyles, CodePanel, AbstractCodeValue } from "../../models";
import { ProductDataStore } from "../../providers/productData";

@Component({
  selector: 'panel-codes-renderer',
  templateUrl: './panelCodesRendererComponent.html',
})
export class PanelCodesRendererComponent extends BaseComponent {

  constructor(public productStore: ProductDataStore) {
    super();
  }

  @Input()
  codeValue: AbstractCodeValue;

  @Input()
  subHeading: string;

  panel: CodePanel;

  displayStyles = CodeDisplayStyles;

  displayStyle: string;

  @Input()
  panelId: number;

  @Input()
  isStored: boolean;

  ngOnInit() {
        
    this.panel = this.productStore.getEntity<CodePanel>(this.panelId);

    this.codeValue.isBinary == true ? this.displayStyle = this.displayStyles.DownloadLink : this.displayStyle = this.panel.displayStyle;

  }
  
}